import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/letter-recommendation/$letterRecommendationId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      search: {
        letterRecommendationId: params.letterRecommendationId,
      },
      to: '/app/letter-recommendation',
    });
  },
  component: () => <div />,
});
